import React, { useMemo } from "react";
import PropTypes from "prop-types";

import PGDashboard from "../../../globals/components/PGDashboard";
import { usePgHomeData } from "../hooks/usePgHomeData";
import { buildDashboardLinkGroups } from "../pgHomeConfig";
import { mapPgDashboardLinkIcons } from "./dashboardLinkIcons";
import PgHomeActivitySection from "./PgHomeActivitySection";
import PgHomeIndemnityDialogs from "./PgHomeIndemnityDialogs";
import HomeShellBase, { buildHomeIndemnityDialogProps } from "./HomeShellBase";
import HomeRightColumnSections from "./HomeRightColumnSections";

/** Professional Guardian (+ contact) orchestration shell — data in {@link usePgHomeData}. */
export default function PgHomeBase({ variant = "guardianUser" }) {
  const home = usePgHomeData(variant);
  const links = useMemo(
    () => mapPgDashboardLinkIcons(buildDashboardLinkGroups({ variant, pg: home.pg })),
    [variant, home.pg]
  );

  const { cfg } = home;
  const sections = cfg.sections || {};

  return (
    <HomeShellBase
      loading={home.loading}
      dashboard={<PGDashboard title={cfg.dashboardTitle} links={links} />}
      leftColumn={
        sections.activity ? (
          <PgHomeActivitySection
            activityCopy={cfg.activity}
            activities={home.activity.activities}
            loadingActivities={home.activity.loadingActivities}
            hasMoreActivities={home.activity.hasMoreActivities}
            selectedActivity={home.activity.selectedActivity}
            onSelectActivity={home.activity.setSelectedActivity}
            onLoadMore={home.activity.loadMoreActivities}
          />
        ) : null
      }
      rightColumn={
        <HomeRightColumnSections
          sections={sections}
          cfg={cfg}
          indemnity={home.indemnity}
          drafts={home.drafts}
        />
      }
      footer={<PgHomeIndemnityDialogs {...buildHomeIndemnityDialogProps(home)} />}
    />
  );
}

PgHomeBase.propTypes = {
  variant: PropTypes.oneOf(["guardianUser", "contact"]),
};
